import { Injectable } from '@angular/core';
import { BankBicOption } from '../../../bank-account/models/bank-account-form.model';
import { BankAccountFormLookupsFacade } from '../../../bank-account/components/bank-account-form-dialog/bank-account-form-lookups.facade';

@Injectable({ providedIn: 'root' })
export class CreditPolicyFormLookupsFacade {
  constructor(private bankAccountLookups: BankAccountFormLookupsFacade) { }

  bics(): Promise<BankBicOption[]> {
    return this.bankAccountLookups.bics();
  }
}
